import * as React from 'react'
import './index.scss'
import Scrollbars from 'react-custom-scrollbars'
import { AwardEvent } from '@pubts/fetch'
import { None } from '@huyafed/comp';
const formatDate: (value: number) => string = value => {
  const now = new Date(value * 1000);
  const hour = now.getHours();     // 返回日期中的小时数（0到23）
  const minute = String(now.getMinutes()); // 返回日期中的分钟数（0到59）
  return hour + ':' + (minute.length === 1 ? '0' + minute : minute);
}
interface Props {
  data: AwardEvent[]
}
const Award: React.FC<Props> = props => {
  return (
    <div className='web-award'>
      <Scrollbars
        style={{
          width: '380px',
          height: '640px',
          position: 'relative',
        }}
        renderThumbVertical={() => <div style={{width: '8px', height: '30px', background: 'rgb(69, 127, 231)', borderRadius: '4px'}} />}
      >
        {
          props.data.length !== 0 ?
            <ul className='web-award-list' style={{height: ((props.data.length * 64) - 64) + 'px'}}>
              {
                props.data.map((item: AwardEvent, index: number) => (
                  <li
                    key={index}
                  >
                    <i></i>
                    <span>{formatDate(item.lLotteryTime)}</span>
                    <span
                      className='name'
                      title={item.sNickName}
                    >{item.sNickName}</span>
                    <span>获得</span>
                    <p title={item.sMsg}>{item.sMsg}</p>
                  </li>
                ))
              }
            </ul>
            :
            <None text='暂无补给记录' />
        }
      </Scrollbars>
    </div>
  )
}
export default Award;